/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".answer-line[_ngcontent-%COMP%]{margin-bottom:10px}  .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{white-space:normal!important}"];
export { styles as styles };
